import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { EagerSelectEffects } from '../../select/eager-select/eager-select-effects';
import { locationOptionActions } from './location-option.actions';
import { locationOptionSelectors } from './location-option.reducer';

@Injectable({ providedIn: 'root' })
export class LocationOptionEffects {
   defaultFields: string[] = [
      'name',
      'houseNumber',
      'locationId',
      'directionalPrefix',
      'streetName',
      'streetNameSuffix',
      'directionalPostfix',
      'timeZoneId',
   ];

   defaultOrderingOptions: string[] = ['houseNumber:asc'];

   staticFilters: string[] = [];

   load = this.eagerSelectEffects.createEagerSelectorLoadEffect(
      locationOptionSelectors.selectState,
      'locations?SerializeEnumsAsStrings=true',
      this.defaultFields,
      this.defaultOrderingOptions,
      locationOptionActions,
      this.staticFilters
   );

   constructor(private eagerSelectEffects: EagerSelectEffects<AppState>, private store: Store) {}
}
